import cssModule from "@vercel/turbopack-next/internal/font/google/cssmodule.module.css?{%22path%22:%22signInWall.ts%22,%22import%22:%22Source_Serif_4%22,%22arguments%22:[{%22subsets%22:[%22latin%22],%22weight%22:%22variable%22,%22axes%22:[%22opsz%22],%22style%22:[%22normal%22,%22italic%22],%22display%22:%22swap%22,%22preload%22:false,%22variable%22:%22--release-serif%22}],%22variableName%22:%22wallSerif%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'Source Serif 4', 'Source Serif 4 Fallback'",
        
    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
